<template>
  <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('Clearing.ProvisionReview')" width="500px" @close="cancel">
    <div class="app-main-inner-row" style="padding-bottom: 10px;">
      <el-form :inline="true" label-width="90px" label-position="left" @submit.native.prevent>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('Clearing.ProvisionDate')">
            <el-date-picker
              no="ProvisionDate"
              type="date"
              style="width:251px;"
              clearable
            />
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer">
      <el-button no="Confirm" type="primary" size="mini">{{ $t('Clearing.Confirm') }}</el-button>
      <el-button no="Cancel" size="mini" @click="cancel">{{ $t('Clearing.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: 'AccrualDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: this.visible
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss">
</style>
